<ngx-ui-loader></ngx-ui-loader>

<!-- Canonical shell (SHELL CONTRACT): page never scrolls; sidebar and content
     scroll independently; .shell-content is the ONLY page scroll region. -->
<div class="app-shell" [class.app-shell--auth]="isLoggedIn()">
    <app-header class="shell-topbar" *ngIf="isLoggedIn()"></app-header>
    <div class="shell-body">
        <app-side-nav class="shell-sidebar" *ngIf="isLoggedIn()"></app-side-nav>
        <main class="shell-content">
            <router-outlet></router-outlet>
            <app-footer *ngIf="isLoggedIn()"></app-footer>
        </main>
    </div>
</div>
